export const NAME = 'nickname';
